import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { PasswordComplexityPolicy } from '@/types/admin-settings';

const CACHE_KEY = 'admin-password-complexity-policy';

export function usePasswordComplexityPolicy() {
    const { data, isLoading } = useSWR<PasswordComplexityPolicy>(
        CACHE_KEY,
        () => AdminSettingsService.getPasswordComplexityPolicy(),
        { revalidateOnFocus: false },
    );

    return { policy: data, isLoading };
}
